exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.number-status-container{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;width:100%;-ms-flex-wrap:nowrap;flex-wrap:nowrap;min-height:40px}[dir] .number-status-container{background-color:#3f3d3d;padding:0}@media (min-width:992px){.number-status-container{min-height:60px}}.number-status-container .number-status-item{color:#ebebeb}[dir] .number-status-container .number-status-item{padding:13px 15px 0 15px}@media (min-width:992px){[dir=ltr] .number-status-container .number-status-item{padding:22px 0 0 30px}[dir=rtl] .number-status-container .number-status-item{padding:22px 30px 0 0}}.number-status-container .number-left{-ms-flex-negative:1;flex-shrink:1}.number-status-container .status-right{-ms-flex-negative:0;flex-shrink:0}[dir=ltr] .number-status-container .status-right{margin-right:30px}[dir=rtl] .number-status-container .status-right{margin-left:30px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/number-status/number-status.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/number-status/number-status.component.scss
// module chunks = 0